import { DiscountMode } from "../../enum";

// The kinds of items a discount can cover.
export type ItemProcessingType = "REGULAR" | "PRESS_ONLY" | "CLEAN_ONLY";
export const ITEM_PROCESSING_TYPES: ItemProcessingType[] = ["REGULAR", "PRESS_ONLY", "CLEAN_ONLY"];
export const PROCESSING_TYPE_LABELS: Record<ItemProcessingType, string> = {
  REGULAR: "Regular",
  PRESS_ONLY: "Press Only",
  CLEAN_ONLY: "Clean Only",
};

// Which items a discount covers: one or more ItemProcessingTypes,
// comma-separated (e.g. "REGULAR,PRESS_ONLY"; multi-select since 2026-11-04).
// Missing means REGULAR (saved before the field existed). ALL is for custom
// discounts and old saved amounts, which cover every item.
export type DiscountProcessingType = string;

export interface IDiscountResponse {
  id: string;
  discountName: string;
  discountAmount: number;
  discountMode: DiscountMode;
  deleted: boolean;
  description: string;
  createdTime: string;
  lastModifiedTime: string;
  merchantId: number;
  storeId: number;
  serviceIds: Array<number>;
  minimumBillValue: number;
  enabled: boolean;
  autoApply: boolean;
  applyToAnyUser: boolean;
  processingType?: DiscountProcessingType | null;
  // Saved on a bill where the discount came to $0 (e.g. Senior on Press
  // Only items). Editing the invoice re-applies it only while it still meets
  // its rules (see resolveLockedDiscount).
  dormant?: boolean;
  // Only set on the client-side custom discount built by the POS modal.
  coverage?: "whole" | "bill" | "custom";
  // Set for "This bill only": the discount applies to this cart session alone.
  sessionId?: string;
}
